/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".navbar[_ngcontent-%COMP%]{-webkit-box-orient:horizontal;-webkit-box-direction:normal;flex-direction:row}"];
export { styles as styles };
